import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	margin-top: 30px;

	transition: opacity 0.25s;
	opacity: 0;

	&.fade-enter {
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
	}

	&.fade-exit-active {
		opacity: 0;
	}
`;

const StyledInput = styled.input.attrs({ placeholder: 'Введите сообщение' })`
	width: 100%;
	height: 40px;
	padding: 11px 45px 11px 10px;

	color: #fff;
	font-family: GT Walsheim Pro;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	border-radius: 10px;
	background-color: rgba(17, 19, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;

	&:focus {
		outline: none;
	}

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
	}
`;

const StyledSendMessageButton = styled.div<{ $active: boolean }>`
	position: absolute;
	top: 5px;
	right: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 10px;
	background-color: ${({ $active }) =>
		$active ? '#2d70da' : 'rgba(255, 255, 255, 0.02)'};
	border: 1px solid
		${({ $active }) => ($active ? 'transparent' : 'rgba(255, 255, 255, 0.05)')};
	cursor: pointer;
	transition:
		background-color 0.25s ease,
		border-color 0.25s ease;

	img {
		filter: invert(0%);
		transition: filter 0.25s ease;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		background-color: #ffffff;
		border-color: transparent;

		img {
			filter: invert(100%);
		}
	}
`;

export { StyledContainer, StyledInput, StyledSendMessageButton };
